export const tiktokPlacements = [
  {
    label: 'Tiktok',
    value: 'PLACEMENT_TIKTOK',
  },
  {
    label: 'Pangle',
    value: 'PLACEMENT_PANGLE',
  },
];
